import {Cookie} from "../../helpers/Cookie";
import helpers from "../../helpers/functions.php";

export class CookieNotice {

    constructor() {
        this.$accept = $('.js-accept-cookies');
        this.$modal = $('.c-cookie-notice');
        this.$close = $('.js-close-cookie-notice');

        this.cookie = new Cookie();
        // bind events
        this.$close.on('click', () => this.close());
        this.$accept.on('click', () => this.acceptOptimalCookies());
    }

    acceptOptimalCookies() {
        this.cookie.set('preference', 'true');
        this.cookie.set('privacyLevel', 'optimal');

        if (helpers.isBijlesnetwerk()) {
            this.cookie.set('privacy-settings', '{"ADVERTISING":true}');
        }

        location.reload();
    }

    acceptMinimalCookies() {
        this.cookie.set('preference', 'true');
        this.cookie.set('privacyLevel', 'minimal');
    }

    close() {
        this.$modal.hide();
        this.acceptMinimalCookies();
    }

}
